
export enum CustomerTabs {
  Transactions = 'Transactions',
  DepositAccounts = 'Deposit Accounts',
  PayoutAccounts = 'Payout Accounts',
}
// TODO: Remove mock when backend is ready
export const depositMock = [{
  id: '7a88c1e9-5c8a-4139-b7cb-441ebb62b54f',
  organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
  name: 'Test',
  status: 'active',
  accountDetails: {
    Crypto: {
      address: '0x990c9921dcd0cc9a8998c53a04296f5ca8c732cb',
      depositMethods: [
        {
          network: 'SepoliaTestnet',
          token: undefined
        },
        {
          network: 'SepoliaTestnet',
          token: '0xa4fCE8264370437e718aE207805b4e6233638b9E'
        },
        {
          network: 'SepoliaTestnet',
          token: '0xE50d86c6dE38F9754f6777d2925377564Bf79482'
        }
      ],
      customerId: undefined,
      isExternal: undefined
    }
  },
  createdAt: '2025-10-06T09:07:30.893522Z',
  customer: undefined
},
{
  id: '7a88c1e9-5c8a-4139-b7cb-441ebb62b54f',
  organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
  name: 'Test',
  status: 'active',
  accountDetails: {
    Crypto: {
      address: '0x990c9921dcd0cc9a8998c53a04296f5ca8c732cb',
      depositMethods: [
        {
          network: 'SepoliaTestnet',
          token: undefined
        },
        {
          network: 'SepoliaTestnet',
          token: '0xa4fCE8264370437e718aE207805b4e6233638b9E'
        },
        {
          network: 'SepoliaTestnet',
          token: '0xE50d86c6dE38F9754f6777d2925377564Bf79482'
        }
      ],
      customerId: undefined,
      isExternal: undefined
    }
  },
  createdAt: '2025-10-06T09:07:30.893522Z',
  customer: undefined
}]

export const withdrawalMock = [
  {
    id: 'f955928e-e0ca-4d37-a3ed-b01cd0ea79df',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'crypto',
    name: "Magnus' Wallet",
    status: 'verified',
    accountDetails: {
      Crypto: {
        network: 'SepoliaTestnet',
        address: '0xC65A3c25B8D88A2e9b56A55D8569564bf28d1820'
      }
    },
    createdAt: '2024-06-19T08:26:44.194157Z'
  },
  {
    id: 'bdb29cc0-450f-46ed-8126-3202be8ade29',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'fiat',
    name: 'Magnus Revolut',
    status: 'verified',
    accountDetails: {
      Fiat: {
        accountOwnerType: 'Individual',
        accountOwnerName: 'Magnus Oliver',
        firstName: null,
        lastName: null,
        accountType: {
          iban: {
            iban: '****************** 6887',
            bic: 'REVOGB21',
            address: null,
            addressV2: null
          }
        }
      }
    },
    createdAt: '2025-03-31T16:15:00.292849Z'
  },
  {
    id: 'f037c66c-fc5e-4cce-9fd6-68374c218357',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'crypto',
    name: 'Magnus Wallet',
    status: 'verified',
    accountDetails: {
      Crypto: {
        network: 'Ethereum',
        address: '0x499f373671BdFB4DEB53A4b387A31a857F0B76E5'
      }
    },
    createdAt: '2025-08-22T14:38:08.824926Z'
  },
  {
    id: 'cfafbb3a-6bcc-4e59-8ccb-0a277ede10cc',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'crypto',
    name: 'Chris',
    status: 'verified',
    accountDetails: {
      Crypto: {
        network: 'Solana',
        address: 'EJQqsrcsn3pHNQEpNcVh1P1f9pxT59Q3ivk8JXSgBh8C'
      }
    },
    createdAt: '2025-11-19T18:09:42.894384Z'
  },
  {
    id: '9ce567d2-1314-4b5f-af8a-ef77d1517d35',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'crypto',
    name: 'TomTest',
    status: 'verified',
    accountDetails: {
      Crypto: {
        network: 'Ethereum',
        address: '0xCD2852A690e99d5545874c616aB21467223D4b29'
      }
    },
    createdAt: '2025-10-09T09:46:06.973162Z'
  },
  {
    id: '4564e076-c4c4-4843-8975-b5d301792223',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'fiat',
    name: "Mateusz's Revolut",
    status: 'verified',
    accountDetails: {
      Fiat: {
        accountOwnerType: 'Individual',
        accountOwnerName: 'Mateusz Paluch',
        firstName: 'Mateusz',
        lastName: 'Paluch',
        accountType: {
          iban: {
            iban: '**************** 7592',
            bic: 'REVOLT21',
            address: null,
            addressV2: null
          }
        }
      }
    },
    createdAt: '2025-12-05T09:17:06.285633Z'
  },
  {
    id: 'abd08efd-a10c-4a13-8583-b235b7170195',
    organizationId: '5e461e24-38fe-44c5-b7df-82914c0e3b52',
    accountType: 'crypto',
    name: 'Magnus Metamask test',
    status: 'verified',
    accountDetails: {
      Crypto: {
        network: 'Ethereum',
        address: '0xE20e3fBbcaBc502F3f4f4666C9043EC8A32780d9'
      }
    },
    createdAt: '2026-01-19T11:46:18.096941Z'
  }
]
